import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { HttpHelperService } from '../http-helper.service';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {

  public user:any ;
  constructor( public service: AmbitService,
    public httpHelper: HttpHelperService,
    public route: ActivatedRoute,
    public router: Router) { 
       if (this.route.snapshot.params['id']) {
         service.passengerId = this.route.snapshot.params['id'] ; 
      }
    }

  ngOnInit() {
    if(this.service.passengersList.length) {
      this.service.getUserDetailData() ;
     }
  }

  getDriverInfo(tripID){
    var self=this ;
    if (self.service.allTrips.length && self.service.allTrips.find(ob => ob['tripID'] === tripID ) ){
      var tripData = self.service.allTrips.find(ob => ob['tripID'] === tripID )
      if (self.service.driversList.length && self.service.driversList.find(ob => ob['uid'] === tripData.uid ) ){
        var driverData = self.service.driversList.find(ob => ob['uid'] === tripData.uid )
        return driverData.userName ;
      } 
    } 
    return '';
  }

  changeUserStatus() {
      var self = this, updateData: any = {}, status = self.service.userDetails.status === false ? true:false ;
      updateData['Users/' + self.service.userDetails.uid + '/status'] = status;
      firebase.database().ref().update(updateData).then(() => {
          self.service.userDetails.status = status ;
          var idx=self.service.passengersList.findIndex(x=> x.uid == self.service.userDetails.uid) ;
          if(idx>=0) { self.service.passengersList[idx].status = status }
          document.getElementById('closeStatusMd').click();
          var notifyData: any = { title: 'Orbit Account Status Is Updated', message: 'Your account is blocked by admin'}
          if(status) { notifyData.message = 'Your account is activated by admin' }
          self.httpHelper.sendEmailNotifications([self.service.userDetails.email], notifyData)
          self.service.sendUserNotification(self.service.driverDetails, notifyData);
      });
  }

}